import { DateTime } from 'luxon';
import { LogEditsState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const logEditState: LogEditsState = {
  // Data filters
  driver: null,
  terminal: null,
  logStatus: null,
  dateRange: {
    fromDate: DateTime.now().minus({ days: 6 }).toISO(),
    toDate: DateTime.now().toISO(),
  },
  isFilterByDriverId: false,
  // Data source
  sortBy: '-last-changed-date',
  sortField: 'last-changed-date',
  logEdits: [],
  logEditsReportData: [],
  // Pagination
  limit: DEFAULT_ROWS_PER_PAGE,
  offset: 0,
  totalRecordCount: 0,
  // Request status
  isRequestPending: false,
  // Export file
  documentType: 'pdf',
  paperOrientation: 'portrait',
  isToggleExportFileModal: false,
  isExportDataRequestPending: false,
};
